













































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import Toggle from '@/components/Toggle.vue';
import moment from 'moment';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import ProjectsData from '@/ts/ProjectsData';
import MultiSelect from 'vue-multiselect';

@Component({
    components: {
        Toggle,
        MultiSelect,
    },
    computed: {
        ...mapGetters({
            facilityAllTypes: 'SharedFacilities/getFacilityAllTypes',
            addAdminFacilityId: 'SharedFacilities/getAddAdminFacilityId',
            facilityAllWatchers: 'SharedFacilities/getFacilityAllWatchers',
        }),
    },
})
export default class AddSharedFacilityForm extends Mixins(InputFieldMethods, NotifyMethods) {
    public project: number|string = '';
    public type: number|string = '';
    public price: number|null = null;
    public facilityName: string = '';
    public facilityInfo: string = '';
    public available: boolean = false;
    public size: string = '';
    public startTime: string = '';
    public endTime: string = '';
    public duration: number|string = 15;
    public minBookableBlocks: number = 0;
    public maxBookableBlocks: number = 0;
    public maxBookingsPerBlock: number = 1;
    public pricePerBlock: string = '';
    public facilityWatchers: any = [];

    public images: File[] = [];
    public bookableDays: string[] = [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
    ];
    public bookableDurations: number[] = [
        15,
        30,
        60,
        120,
    ];
    public facilityHours: any = [];
    public weekDays: string[] = [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun',
    ];
    public bookingOptions: string[] = [
        'daily',
        'hourly',
        'block',
    ];
    public selectedBookingOption: string = 'daily';
    public maxImagesCountError: boolean = false;
    public alert: any = { color: 'teal', message: this.$t('shared-facilities.block-config-changed', 'Block configuration has been changed'), icon: 'warning_amber' };

    constructor() {
        super();
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    get mainImage() {
        return this.images[0];
    }

    get secondaryImages() {
        return this.images.filter((image: File, index: number) => {
            return index > 0;
        });
    }

    get currentAddAdminFacilityId() {
        return this.$store.getters['SharedFacilities/getAddAdminFacilityId'];
    }

    get bookableBlocksMaxRule() {
        return !this.availabilityRangeDuration
            ? false
            : this.availabilityRangeDuration / Number(this.duration);
    }

    get maxBlockDurationRule() {
        const maxDurationOption = this.bookableDurations[this.bookableDurations.length - 1];

        if (!this.availabilityRangeDuration || this.availabilityRangeDuration > maxDurationOption) {
            return maxDurationOption;
        }

        return this.availabilityRangeDuration;
    }

    get availabilityRangeDuration() {
        if (this.startTime === '' || this.endTime === '') {
            return false;
        }

        const from = moment(this.startTime, 'h:mm A');
        const till = moment(this.endTime, 'h:mm A');
        const diffInMinutes = till.diff(from, 'minutes');

        return diffInMinutes !== 59 ? diffInMinutes : 60;
    }

    @Watch('startTime')
    public startTimeChanged() {
        let showNotify = false;

        if (this.availabilityRangeDuration && this.duration > this.availabilityRangeDuration) {
            this.duration = this.availabilityRangeDuration;
            showNotify = true;
        }

        if (this.availabilityRangeDuration && Number(this.maxBookableBlocks) > this.bookableBlocksMaxRule) {
            // @ts-ignore
            this.maxBookableBlocks = this.bookableBlocksMaxRule;
            showNotify = true;
        }

        if (this.availabilityRangeDuration && Number(this.minBookableBlocks) >= this.maxBookableBlocks) {
            this.minBookableBlocks = this.maxBookableBlocks;
            showNotify = true;
        }

        if (showNotify) {
            this.showNotification();
        }
    }

    @Watch('endTime')
    public endTimeChanged() {
        let showNotify = false;

        if (this.availabilityRangeDuration && this.duration > this.availabilityRangeDuration) {
            this.duration = this.availabilityRangeDuration;
            showNotify = true;
        }

        if (this.availabilityRangeDuration && Number(this.maxBookableBlocks) > this.bookableBlocksMaxRule && Number(this.maxBookableBlocks) !== 0) {
            // @ts-ignore
            this.maxBookableBlocks = this.bookableBlocksMaxRule;
            showNotify = true;
        }

        if (this.availabilityRangeDuration && Number(this.minBookableBlocks) >= this.maxBookableBlocks  && Number(this.minBookableBlocks) !== 0) {
            this.minBookableBlocks = this.maxBookableBlocks;
            showNotify = true;
        }

        if (showNotify) {
            this.showNotification();
        }
    }

    public setCorrectStep() {
        const durationNumber = Number(this.duration);

        this.duration = this.bookableDurations.reduce((previous: number, currrent: number) => {
            return (Math.abs(currrent - durationNumber) < Math.abs(previous - durationNumber) ? currrent : previous);
        });
    }

    public compareTimes(targetTime: string, relativeTime: string, direction: string) {
        if (relativeTime === '') {
            return false;
        }

        const startTime = targetTime;
        const endTime   = relativeTime;

        const momentStartTime = moment(startTime, 'h:mm A');
        const momentEndTime   = moment(endTime, 'h:mm A');

        return direction === 'before'
            ? momentStartTime.isSameOrBefore(momentEndTime)
            : momentStartTime.isSameOrAfter(momentEndTime);
    }

    public toggleBookableDays(day: string) {
        if (this.bookableDays.indexOf(day) >= 0) {
            this.bookableDays = this.bookableDays.filter((bookableDay: string) => bookableDay !== day);
        } else {
            this.bookableDays.push(day);
        }
    }

    public makeWeekDaysArray() {
        this.weekDays = moment.weekdaysShort(true);
    }

    public makeHoursArray() {
        for (let hourIndex = 0; hourIndex < 24; hourIndex++) {
            this.facilityHours.push(moment({hour: hourIndex}).format('h:mm A'));
        }

        this.facilityHours.push(moment('23:59:59', 'HH:mm:ss').format('h:mm A'));
    }

    public deleteImage(index: number) {
        this.maxImagesCountError = false;
        this.images = this.images.filter((image: File, imageIndex: number) => {
            return imageIndex !== index;
        });
    }

    public imagePreview(imageIndex: number) {
        const image = this.images[imageIndex];
        return URL.createObjectURL(image);
    }

    public addFacilityImage() {
        if (!this.currentAddAdminFacilityId) {
            return this.notify('please_create_facility_before_uploading_photos', 'warning');
        }

        const element = (this.$refs.imageInput as HTMLInputElement);

        if (this.images.length < 5) {
            this.images.push(element.files[0] as File);
        } else {
            this.maxImagesCountError = true;
        }

        element.type = 'text';
        element.type = 'file';
        element.value = null;
    }

    public uploadFacilityPhotos(facilityId: number) {
        const formData: any = new FormData();
        formData.append('facilityId', facilityId);

        for (let k = 0; k < this.images.length; k++) {
            formData.append(k, this.images[k]);
        }

        this.$store.dispatch(Actions.ADD_PHOTOS_TO_NEW_FACILITY, {requestData: formData, facilityId});
    }

    public showNotification() {
        this.$q.notify({
            color: this.alert.color,
            icon: this.alert.icon,
            message: this.alert.message,
            position: 'bottom-right',
            timeout: Math.random() * 5000 + 3000,
        });
    }

    public createFacility() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                if ((this.selectedBookingOption === 'hourly' || this.selectedBookingOption === 'block') && (this.startTime === '' || this.endTime === '')) {
                    return this.notify('from_and_till_times_are_required', 'warning');
                }

                if (!this.bookableDays.length) {
                    return this.notify('please_select_at_least_one_day', 'warning');
                }

                if (this.selectedBookingOption === 'block' && this.maxBookableBlocks === 0) {
                    return this.notify('max_bookable_slots_cannot_be_zero', 'warning');
                }

                this.$store.dispatch(Actions.ADD_NEW_FACILITY, {
                    project: this.project,
                    type: this.type,
                    price: this.price,
                    facilityName: this.facilityName,
                    facilityInfo: this.facilityInfo,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    bookableDays: this.bookableDays,
                    selectedBookingOption: this.selectedBookingOption,
                    available: this.available,
                    duration: this.selectedBookingOption ? this.duration : 0,
                    minBookableBlocks: this.selectedBookingOption ? this.minBookableBlocks : 0,
                    maxBookableBlocks: this.selectedBookingOption ? this.maxBookableBlocks : 0,
                    maxBookingsPerBlock: this.selectedBookingOption ? this.maxBookingsPerBlock : 0,
                    blockPrice: this.selectedBookingOption ? this.pricePerBlock : 0,
                    watchers: this.facilityWatchers.map((watcher: any) => watcher.id),
                });
            }
        });
    }

    public created() {
        this.makeHoursArray();
        this.$store.dispatch(Actions.FETCH_ALL_FACILITY_TYPES);
        this.$store.commit(Mutations.SET_ADD_FACILITY_ID, 0);
        this.$store.dispatch(Actions.FETCH_FACILITY_ALL_WATCHERS);
    }
}
